import { Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useSettings } from 'context/SettingsContext';
import StockLotsTableBody from './StockLotsTableBody';
import type { StockLotRow } from './types';

export type { StockLotRow };

interface StockLotsTableProps {
    rows: StockLotRow[];
    plainStock?: boolean;
}

const StockLotsTable = ({ rows, plainStock = false }: StockLotsTableProps) => {
    const { t } = useTranslation(['Warehouses']);
    const { localSettings } = useSettings();
    const isUahMode = (Number(localSettings?.RATE?.current ?? 1) || 1) === 1;
    const showPrices = rows.some((row) => row.operPrice != null);
    const showRate = showPrices && !isUahMode;

    return (
        <Table size={plainStock ? 'sm' : undefined} className={`StockLotsTable table-hover${plainStock ? ' mb-0' : ''}`}>
            {!plainStock && (
                <thead>
                    <tr className="bg-light">
                        {showPrices && <td className="head-price">{t('labelPrice')}</td>}
                        {showRate && <td className="head-rate">{t('labelRate')}</td>}
                        <td className="head-count">{t('labelMax')}</td>
                    </tr>
                </thead>
            )}
            <StockLotsTableBody
                rows={rows}
                showPrices={showPrices}
                showRate={showRate}
                isUahMode={isUahMode}
                plainStock={plainStock}
            />
        </Table>
    );
};

export default StockLotsTable;
